import {
    actionCreator,
    manageDatabaseActionTypes,
    checkHttpStatus,
    jsonApiHeader,
    createSearchUrlForCustomAPI,
    showSuccessMessage,
    showErrorMessage,
    showWarningMessage,
    GET_ORGANISATION_DATABASE_DETAIL_API,
} from '../constants/ApiConstants';
import GlobalVariables from '../../../../../actions/utilAction';

//GET DATABASE DETAILS
export const getOrganizationDatabaseDetail = (searchObj) => {
    let queryParams = createSearchUrlForCustomAPI(searchObj)
    return (dispatch, getState) => {
        dispatch(actionCreator(manageDatabaseActionTypes.getOrganizationDatabaseDetail.REQUEST));
        fetch(`${GET_ORGANISATION_DATABASE_DETAIL_API}${queryParams}`, {
            method: 'GET',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                dispatch(actionCreator(manageDatabaseActionTypes.getOrganizationDatabaseDetail.SUCCESS, response));
            })
            .catch(function (error) {

            });
    };
};


//SAVE DATABASE
export const saveDatabase = (formData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageDatabaseActionTypes.post_database.REQUEST));

        let saveData = JSON.stringify(formData);
        let requestType = (formData.databaseDetailID) ? 'PATCH' : 'POST';
        let postAPI = (formData.databaseDetailID) ? `${GET_ORGANISATION_DATABASE_DETAIL_API}/${formData.databaseDetailID}` : `${GET_ORGANISATION_DATABASE_DETAIL_API}`;
       
       // console.log('postData-------', saveData)
        fetch(postAPI, {
            method: requestType,
            body: saveData,
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response) {
                   // console.log("response of post method---------", response);
                    dispatch(actionCreator(manageDatabaseActionTypes.post_database.SUCCESS, response));
                    if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                        showSuccessMessage(response.message);
                        let searchObj = {
                            sort_fields: 'databaseDetailID',
                            sort_order: 'desc',                            
                            pageSize: GlobalVariables.PageSize,
                            pageNumber: 1,
                        };
                        dispatch(getOrganizationDatabaseDetail(searchObj));
                    } else {
                        showErrorMessage(response.message);
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
};

// DELETE DATABASE
export const deleteDatabase = (databaseId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(manageDatabaseActionTypes.delete_database.REQUEST));
        fetch(`${GET_ORGANISATION_DATABASE_DETAIL_API}/${databaseId}`, {
            method: 'DELETE',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response) {
                   // console.log("response of delete method-----------", response);
                    dispatch(actionCreator(manageDatabaseActionTypes.delete_database.SUCCESS, response));
                    if (response.statusCode === 204) {
                        showSuccessMessage(response.message);                        
                    } else {
                        showWarningMessage(response.message);
                    }
                    let searchObj = {
                        sort_fields: 'databaseDetailID',
                        sort_order: 'desc',
                        pageSize: GlobalVariables.PageSize,
                        pageNumber: 1,
                    };
                    dispatch(getOrganizationDatabaseDetail(searchObj));
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
};


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageDataBase/actions/ManageDataBaseAction.js